/**
 * Where the partner API's OpenAPI documentation lives, or null when this build
 * has none to offer.
 *
 * Customers reach the API, and its docs, on the relay's hostname, which is
 * configured per environment rather than guessed here: nothing in this repo
 * may point a customer at the indexer. Only http(s) addresses count, so a
 * mistyped or hostile value cannot become a `javascript:` link.
 */
export function partnerApiDocsUrl(): string | null {
    const raw: unknown = import.meta.env.VITE_PARTNER_API_DOCS_URL;
    if (typeof raw !== 'string') return null;
    const value = raw.trim();
    return /^https?:\/\/[^\s/][^\s]*$/i.test(value) ? value : null;
}
